import type { Epic } from 'Flux/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import { authenticationExpiredOr } from 'Framework/Epic/AuthenticationExpired.js'
import { catchError, filter, mergeMap, of } from 'rxjs'
import type { AjaxError } from 'rxjs/ajax'

export const GetOtuCountEpic: Epic = (action$, state$, { [orderSlice.name]: order, OrderRepository }) =>
  action$.pipe(
    filter(order.getOtuCountRequest.match),
    mergeMap((action) => {
      return OrderRepository.getOtuCount(action.payload.orderId).pipe(
        mergeMap((response) => of(order.getOtuCountSuccess(response))),
        catchError((error: AjaxError) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            failureAction: of(order.getOtuCountFailure({ error }))
          })
        )
      )
    })
  )
